// extracted by mini-css-extract-plugin
export default {"tickets":"styles_tickets__jppby"};